import { LANGUAGES } from "@/lib/languages";

export const LOCALE_MAP: Record<string, string> = Object.fromEntries(
  LANGUAGES.map(l => [l.polylangCode, l.polylangLocale])
);
// Result: { "pt": "pt-PT", "es": "es-ES" }